import React from "react";

export default function WidgetGrid(props) {
  const { rows, columns, widgetLocations, containingWidgets, createChildWidget } = props;

  let rowHeightSum = (rows.reduce((pv, cv) => pv + cv.Height, 0));
  let columnWidthSum = (columns.reduce((pv, cv) => pv + cv.Width, 0));
  
  const cellStyle = loc => ({
    gridArea: loc.Row + 1 + " / " + (loc.Col + 1) + " / span " + loc.RowSpan + " / span " + loc.ColSpan
    //border: "1px solid"
  });

  const gridStyle = () => ({
    display: "grid" /* display: inline-grid;*/,
    height: "100%",
    gridTemplateRows: rows.map(row => toSizeDefinition(row.Height, rowHeightSum, row.TakeAdditionalSpace)).join(" "),
    gridTemplateColumns: columns.map(column => toSizeDefinition(column.Width, columnWidthSum, column.TakeAdditionalSpace)).join(" ")
  });

  const toSizeDefinition = (size, overallSize, takeSpace) => {
    if (takeSpace) return "minmax(" + size + "em," + toWeightedFraction(size, overallSize) + ")";
    else return size + "em";
  };

  const toWeightedFraction = (size, overallSize) => {
    //return ((size*100)/overallSize)*10 + "fr";
    let percentage = (size*100)/overallSize;
    let fractional = percentage*100;
    return fractional + "fr";
  };

  const renderChildWidget = widgetRef => {
    if (!containingWidgets) return;
    let childWidgetUi = containingWidgets.find(widget => widget.id === widgetRef);
    return createChildWidget(childWidgetUi);
  };
 
  return (
    <div style={gridStyle()}>
      {widgetLocations.map((widgetLocation, index) => (
        <div key={index} style={cellStyle(widgetLocation)}>
          {renderChildWidget(widgetLocation.WidgetRef)}
        </div>
      ))}
    </div>
  );
}

